export default __webpack_public_path__ + "static/perfect_circuit-d21853ad2388b8ed328d6171416d92e6.png";